module.exports = __webpack_public_path__ + "static/img/9.6650775.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/app/9.jpg
// module id = LUKC
// module chunks = 0